import { createSlice } from '@reduxjs/toolkit'

const dmSlice = createSlice({
    name: 'dm',
    initialState: {
        unreadByRoom: {}
    },
    reducers: {
        setRoomUnread(state, { payload: { roomJid, count } }) {
            state.unreadByRoom[roomJid] = count
        },
        markRoomRead(state, { payload: roomJid }) {
            state.unreadByRoom[roomJid] = 0
        },
        incrementRoomUnread(state, { payload: roomJid }) {
            state.unreadByRoom[roomJid] = (state.unreadByRoom[roomJid] ?? 0) + 1
        }
    }
})

export const { setRoomUnread, markRoomRead, incrementRoomUnread } =
    dmSlice.actions

export const selectTotalUnread = (state) =>
    Object.values(state.dm.unreadByRoom).reduce((sum, n) => sum + n, 0)

export const selectRoomUnread = (state, roomJid) =>
    state.dm.unreadByRoom[roomJid] ?? 0

export default dmSlice.reducer
